import * as React from "react";
import { useEffect, useState } from "react";
import { IJobsheet } from "../../../interfaces/jobsheets/IJobsheet";
import * as webHelpers from "../../../helpers/WebHelpers";
import "./styles.scss";
import { ISearchResult, ISearchResultResponse } from "../../../interfaces/postcodesearch/ISearchResult";
//@ts-ignore
import { GridItem, Editable, EditableInput, EditableTextarea, EditablePreview, Button, Select, Tabs, TabList, Tab, TabPanels, TabPanel, Avatar, Flex, Text, HStack, VStack, Divider, Stack, Box, Alert, AlertIcon, AlertTitle, Heading, Input, InputGroup, InputLeftAddon, InputRightElement, Badge, Image, Grid, Wrap, WrapItem } from "@chakra-ui/react";
import JS from "../../../DummyResponse/Jobsheet.json";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import CustomerDetails, { ICustomerDetails } from "../../components/CustomerDetails";
import { PageContainer, PortalPageType } from "../../components/container";
import { IAddress } from "../../../interfaces/contractors/IAddress";
import { CustomerType, ICustomer } from "../../../interfaces/jobsheets/ICustomer";
import { IContact } from "../../../interfaces/jobsheets/IContact";
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import loadingGif from "../../../assets/loadingIcon.gif"
import timedOutGif from "../../../assets/loadingErrorScreen.png"
import { FaUserAlt, FaMobileAlt } from "react-icons/fa"
import { BsFillTelephoneFill } from "react-icons/bs"
import { MdOutlineAlternateEmail, MdEmail } from "react-icons/md"
import { BsFillHouseFill } from "react-icons/bs";
import { BeautifyString } from "../../../helpers/StringHelpers";



export default function DetailsPage() {
	const [jobsheet, setJobsheet] = useState<IJobsheet>();
	const { jobNumber } = useParams();
	const sendDataToGTM = useGTMDispatch();

	const [customerDetails, setCustomerDetails] = useState<ICustomerDetails>();

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isSaving, setIsSaving] = useState<boolean>(false);
	const [showSuccess, setShowSuccess] = useState<boolean>(false);
	const [showError, setShowError] = useState<boolean>(false);
	const [errorMessages, setErrorMessages] = useState<string[]>([]);

	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [manualAddressEntryMode, setManualAddressEntryMode] = useState(true);
	const [postcodeSearch, setPostcodeSearch] = useState("");
	const [searchResults, setSearchResults] = useState<ISearchResult[]>();

	const updateDetails = (details: ICustomerDetails, errors: string[]) => {
		setCustomerDetails(details);
		setErrorMessages(errors);
	}

	function updateFields(js: IJobsheet) {
		let initialData: ICustomerDetails = {
			title: js.customer?.Billing.Contact.Salutation != null ? js.customer.Billing.Contact.Salutation : '',
			business_name: (js.customer?.Type == CustomerType.PrivateBusiness || js.customer?.Type == CustomerType.PublicSector) ? js.customer.Name : '',
			first_name: js.customer?.Billing.Contact.FirstName != null ? js.customer.Billing.Contact.FirstName : '',
			last_name: js.customer?.Billing.Contact.LastName != null ? js.customer.Billing.Contact.LastName : '',
			mobile: js.customer?.Billing.Contact.MobileNumber != null ? js.customer.Billing.Contact.MobileNumber : '',
			landline: js.customer?.Billing.Contact.LandLine != null ? js.customer.Billing.Contact.LandLine : '',
			email: js.customer?.Billing.Contact.EmailAddress != null ? js.customer.Billing.Contact.EmailAddress : '',
			address: {
				line1: js.customer?.Billing.Address.line1 != null ? js.customer.Billing.Address.line1 : '',
				line2: js.customer?.Billing.Address.line2 != null ? js.customer.Billing.Address.line2 : '',
				line3: js.customer?.Billing.Address.line3 != null ? js.customer.Billing.Address.line3 : '',
				line4: js.customer?.Billing.Address.line4 != null ? js.customer.Billing.Address.line4 : '',
				post_code: js.customer?.Billing.Address.post_code != null ? js.customer.Billing.Address.post_code : ''
			}

		}
		setCustomerDetails(initialData);
	}

	const getJobsheet = async (id: string) => {
		setIsLoading(true);
		console.log(id);
		let js = webHelpers.getAsync<IJobsheet | null>(
			"/api/sales/work/jobsheet" + (id == null ? "" : "?job=" + id),
			//undefined, JS //Comment out if running server
		);
		js.then(data => {
			if (data !== null) {
				setJobsheet(data);
				updateFields(data);
				console.log(data);
			} else {
				console.log(`${data} : unable to get jobsheet information`);
			}
		})
		js.catch((err) => {
			console.log(err);
			// Expected output: Jobsheet not found
		})
		js.finally(() => {
			setIsLoading(false);
		})
	};

	const handleSave = async () => {
		setIsSaving(true);
		setShowSuccess(false);
		console.log("Save billing details");
		if (customerDetails != null) {
			if (errorMessages.length > 0) {
				setShowError(true);
			} else {
				let responseA = webHelpers.postAsync<ICustomer, any>(
					"/api/sales/customer/account/update",
					{
						id: jobsheet?.customer_id,
						billing_address: customerDetails.address
					}
				);

				console.log(jobsheet?.customer_id);
				console.log(jobsheet?.customer?.Billing.ContactId);

				let responseB = webHelpers.postAsync<IContact, any>(
					"/api/sales/contact/update",
					{
						id: jobsheet?.customer?.Billing.ContactId,
						customerDetails
					}
				);

				await responseA;
				console.log(responseA);
				await responseB;
				console.log(responseB);

				if (responseA == null || responseB == null) {
					setErrorMessages(["Error updating your billing details. If issue persists, contact customer service."]);
					setShowError(true);
				} else {
					console.log("Saved successfully");
					setErrorMessages([]);
					setShowError(false);
					setShowSuccess(true);
					sendDataToGTM({ event: "billing_details_saved" });
				}
			}
		} else {
			setErrorMessages(["Customer details are missing. Please contact customer service."]);
			setShowError(true);
		}
		setIsSaving(false);
	}

	useEffect(() => {
		if (jobsheet === undefined) {
			if (jobNumber != null) {
				getJobsheet(jobNumber);
			}
			else {
				navigate("/customer/signout");
			}
		}
	}, []);

	return (
		<PageContainer pageTitle="Your Details" type={PortalPageType.Customer}>
			<Flex direction='column' w='full'>
				{(jobsheet?.customer?.DefaultContact) ?
					<>
						<Flex direction='column' w='full' mt={5}>
							<Heading mb={2} size='md' color='var(--Able-blue)' p={2} borderBottom='2px' borderColor='gray.200'>Personal Details</Heading>

							<Flex justify='left'>
								<Flex direction='column' gap={2} p={2} w={600}>
									<InputGroup>
										<InputLeftAddon w={{ base: 75, md: 160 }} color={"white"} backgroundColor={"var(--Able-blue)"}>Name</InputLeftAddon>
										<Input placeholder="None" value={BeautifyString(jobsheet.customer.Name)} readOnly />
									</InputGroup>
									<InputGroup>
										<InputLeftAddon w={{ base: 75, md: 160 }} color={"white"} backgroundColor={"var(--Able-blue)"}>Email</InputLeftAddon>
										<Input placeholder="Unknown" value={jobsheet.customer.DefaultContact.EmailAddress ? jobsheet.customer.DefaultContact.EmailAddress : "None"} readOnly />
									</InputGroup>
									<InputGroup>
										<InputLeftAddon w={{ md: 160 }} color={"white"} backgroundColor={"var(--Able-blue)"}>Contact Number</InputLeftAddon>
										<Input placeholder="Unknown" value={jobsheet.customer.DefaultContact.MobileNumber ? jobsheet.customer.DefaultContact.MobileNumber :
											jobsheet.customer.DefaultContact.LandLine ? jobsheet.customer.DefaultContact.LandLine : "None"} readOnly />
										{/* {jobsheet.customer.DefaultContact.MobileNumber ? <InputRightElement w='full' h='full' children={<Badge p={1}>Mobile</Badge>} pointerEvents='none'/> :
									jobsheet.customer.DefaultContact.LandLine ? <InputRightElement children={<Badge p={1}>Landline</Badge>} pointerEvents='none'/> : <></>} */}

									</InputGroup>
								</Flex>
							</Flex>
						</Flex>

						<Flex direction='column' w='full' mt={5}>
							<Heading mb={2} size='md' color='var(--Able-blue)' p={2} borderBottom='2px' borderColor='gray.200'>Billing Details</Heading>

							<Flex direction='row' wrap='wrap' gap={4} p={2}>
								<Flex direction='column' justify='space-between' gap={2} w='450px'>
									<InputGroup marginTop={"1px"}>
										<InputLeftAddon bg={"var(--Able-blue)"} color={"white"}><FaUserAlt /></InputLeftAddon>
										<Input contentEditable={false} readOnly={true} value=
											{BeautifyString(jobsheet.customer.DefaultContact.Salutation + " " + jobsheet.customer.DefaultContact.FirstName + " " + jobsheet.customer.DefaultContact.LastName)}>
										</Input>
									</InputGroup>

									<InputGroup>
										<InputLeftAddon bg={"var(--Able-blue)"} color={"white"}><FaMobileAlt /></InputLeftAddon>
										{/* @ts-ignore */}
										<Input contentEditable={false} readOnly={true} value={jobsheet.customer.DefaultContact.MobileNumber}></Input>
									</InputGroup>

									<InputGroup>
										<InputLeftAddon bg={"var(--Able-blue)"} color={"white"}><BsFillTelephoneFill /></InputLeftAddon>
										{/* @ts-ignore */}
										<Input contentEditable={false} readOnly={true} value={jobsheet.customer.DefaultContact.LandLine}></Input>
									</InputGroup>

									<InputGroup>
										<InputLeftAddon bg={"var(--Able-blue)"} color={"white"}><MdOutlineAlternateEmail /></InputLeftAddon>
										{/* @ts-ignore */}
										<Input contentEditable={false} readOnly={true} value={jobsheet.customer.DefaultContact.EmailAddress}></Input>
									</InputGroup>
								</Flex>

								<Flex direction='column' w='450px'>
									<InputGroup borderBottomColor={"white"} borderBottomLeftRadius={"0px"} >
										<InputLeftAddon bg={"var(--Able-blue)"} color={"white"} borderBottomRadius={"0"}><BsFillHouseFill /></InputLeftAddon>
										{/* @ts-ignore */}
										<Input contentEditable={false} readOnly={true} value={customerDetails?.address.post_code} borderBottomRadius={"0"}></Input>
									</InputGroup>
									<InputGroup marginTop={"-3px"} borderTopColor={"white"} borderTopWidth={"0px"} borderBottomColor={"white"}>
										<InputLeftAddon bg={"var(--Able-blue)"} color={"var(--Able-blue)"} borderTopColor={"var(--Able-blue)"} borderRadius={"0"}><BsFillHouseFill /></InputLeftAddon>
										{/* @ts-ignore */}
										<Input contentEditable={false} readOnly={true} value={BeautifyString(customerDetails?.address.line1)}></Input>
									</InputGroup>
									<InputGroup marginTop={"-3px"} borderTopColor={"white"} borderTopWidth={"0px"} borderBottomColor={"white"}>
										<InputLeftAddon bg={"var(--Able-blue)"} color={"var(--Able-blue)"} borderTopColor={"var(--Able-blue)"} borderRadius={"0"}><BsFillHouseFill /></InputLeftAddon>
										{/* @ts-ignore */}
										<Input contentEditable={false} readOnly={true} value={BeautifyString(customerDetails?.address.line2)}></Input>
									</InputGroup>
									<InputGroup marginTop={"-3px"} borderTopColor={"white"} borderTopWidth={"0px"} borderBottomColor={"white"}>
										<InputLeftAddon bg={"var(--Able-blue)"} color={"var(--Able-blue)"} borderTopColor={"var(--Able-blue)"} borderRadius={"0"}><BsFillHouseFill /></InputLeftAddon>
										{/* @ts-ignore */}
										<Input contentEditable={false} readOnly={true} value={BeautifyString(customerDetails?.address.line3)}></Input>
									</InputGroup>
									<InputGroup marginTop={"-3px"} borderTopColor={"white"} borderTopWidth={"0px"}>
										<InputLeftAddon bg={"var(--Able-blue)"} color={"var(--Able-blue)"} borderTopColor={"var(--Able-blue)"} borderTopRadius={"0"}><BsFillHouseFill /></InputLeftAddon>
										{/* @ts-ignore */}
										<Input contentEditable={false} readOnly={true} value={BeautifyString(customerDetails?.address.line4)}></Input>
									</InputGroup>
								</Flex>
							</Flex>
						</Flex>
					</>
				:
					<>
						<Flex direction='column' justifyContent={"center"} width={"100%"}>
							{isLoading ?
								<Image srcSet={loadingGif} alt="loading..." boxSize={'400px'} objectFit={"cover"} marginLeft={"35%"} marginTop={"10%"} />
								:
								<Image srcSet={loadingGif} alt="loading..." boxSize={'400px'} objectFit={"cover"} marginLeft={"35%"} marginTop={"10%"} />
							}
						</Flex>
					</>
				}
			</Flex>
		</PageContainer>
	)
}